import {RRLogisticType} from "../../views/logistics/RRLogisticType";
import {timeToString} from "../../tools";
import {Badge, Button, Col, Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons";
import React from "react";

interface MLogiticsDayDetailsItemProps {
    logistic: RRLogisticType;
    onClick: (logistic: RRLogisticType) => void;
}

export default function MLogiticsDayDetailsItem({logistic, onClick}: MLogiticsDayDetailsItemProps) {
    return (<>
        <div
            className={"border rounded mt-2 p-2 text-dark " + (logistic.workInStore ? "bg-info" : "bg-warning")}
            onClick={() => onClick(logistic)}
        >

            <Row>
                <Col>
                    <Row>
                        <Col>
                            {logistic.driverName}
                        </Col>
                        <Col>
                            {
                                logistic.workInStore ?
                                    <div className={"small fst-italic mb-2"}>Работа в склад</div> : <>
                                        <div className={"mb-1 fw-bold"}>{logistic.eventNumber}</div>
                                        <div>
                                            {
                                                [logistic.truck.name, logistic.truck.plate].filter(
                                                    item => item !== ""
                                                ).join(", ")
                                            }
                                        </div>
                                    </>
                            }
                        </Col>
                    </Row>
                </Col>
                <Col xs={"auto"} className={"fw-bold text-dark"}>
                    <div>
                        <Badge bg={"dark"}>
                            {timeToString(logistic.startDate)}
                        </Badge>-
                        <Badge bg={"dark"}>
                            {timeToString(logistic.endDate)}
                        </Badge>
                    </div>
                    {
                        !logistic.workInStore && (
                        logistic.reportStartDate && logistic.reportEndDate ?
                            <div>
                                <Badge bg={"dark"}>
                                    {timeToString(logistic.reportStartDate)}
                                </Badge>-<Badge bg={"dark"}>
                                    {timeToString(logistic.reportEndDate)}
                                </Badge>
                            </div> :
                            <div className={"text-end mt-2"}>
                                <Button variant={"secondary"} size={"sm"}>
                                    ...
                                </Button>
                            </div>
                        )
                    }
                </Col>
            </Row>
            {
                logistic.planNotes &&
                <div className={"border border-0 border-top border-dark mt-2 pt-2"}>
                    <FontAwesomeIcon icon={faInfoCircle}/>&nbsp;
                    {logistic.planNotes}
                </div>
            }
        </div>
    </>);
}
